export const SECTION_KEYS = {
  CERTIFICATIONS: 'certifications',
  SKILLS_AND_LANGUAGES: 'skillsAndLanguages',
  WORK_HISTORY: 'workHistory',
  PERSONALITY: 'personality',
  AVAILABILITY: 'availability',
  TRAVEL_PREFERENCES: 'travelPreferences',
  WORK_ELIGIBILITY: 'workEligibility',
  CONTACT: 'contact',
  AGREEMENTS: 'agreements',
  CONFIRM: 'confirm',
  INTERVIEW: 'interview',
};
